"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayUtils = void 0;
var js_utils_1 = require("./js-utils");
/**
 * @author arnozhang
 * @date 2019/06/25
 */
var TAG = 'ArrayUtils';
var ArrayUtils = /** @class */ (function () {
    function ArrayUtils() {
    }
    ArrayUtils.newArray = function (length, value) {
        return new Array(length).fill(value);
    };
    ArrayUtils.arrayContains = function (array, value) {
        if (js_utils_1.JsUtils.isEmpty(array)) {
            return false;
        }
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var item = array_1[_i];
            if (item == value) {
                return true;
            }
        }
        return false;
    };
    ArrayUtils.removeArrayByIndex = function (array, from, to) {
        var rest = array.slice((to || from) + 1 || array.length);
        array.length = from < 0 ? array.length + from : from;
        return array.push.apply(array, rest);
    };
    return ArrayUtils;
}());
exports.ArrayUtils = ArrayUtils;
